import { ErrorLike } from '@/apis/types';

/**
 * Handles unauthorized errors by logging out the user
 *
 * @param error - Error object that may contain a status code
 * @param navigate - Function to navigate to different routes
 * @param removeToken - Function to remove authentication token
 */
export const unAuth = (
  error: ErrorLike | undefined,
  navigate: (path: string) => void,
  removeToken: () => void
): void => {
  if (error?.status === 401) {
    removeToken();
    localStorage.removeItem('token');
    navigate('/login');
  }
};
